// Egg records own their report and canonical active-group choices. Existing
// historical names remain selectable when inactive or the directory fails.
import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'layer.eggDailys.detail',
  obligations: Object.freeze([
    Object.freeze({id: 'layer.eggDaily.detail', owner: 'permanent'}),
    Object.freeze({id: 'layer.eggDailys.groups', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
